export type AppIconName = 'github' | 'google';
export type AppIconSurface = 'light' | 'dark';

type AppIconDefinition = Record<AppIconSurface, string>;

const githubLight = new URL('./assets/app-icons/github-light.svg', import.meta.url).href;
const githubDark = new URL('./assets/app-icons/github-dark.svg', import.meta.url).href;
const googleIcon = new URL('./assets/app-icons/google.svg', import.meta.url).href;

export const appIcons: Record<AppIconName, AppIconDefinition> = {
  github: {
    light: githubLight,
    dark: githubDark,
  },
  google: {
    light: googleIcon,
    dark: googleIcon,
  },
};

export function getAppIconUrl(name: AppIconName, surface: AppIconSurface = 'light'): string {
  return appIcons[name][surface];
}
